import MORE_CHEVRON_IMAGE from '../../../assets/images/time-nyang/more-chevron.svg';

export default function TimeNyangPlayLogCard({
  bestLog,
  visiblePlayLogs,
  shouldShowPlayLogToggle,
  isLogsExpanded,
  onToggleLogs,
}) {
  return (
    <section className="mt-3.5 flex min-h-[160px] flex-col rounded-[10px] bg-white px-2.5 py-[18px] shadow-[0_5px_16px_rgba(0,0,0,0.1)]">
      <div className="flex items-center justify-between px-[5px]">
        <p className="font-['Pretendard'] text-sm font-bold tracking-[-0.5px] text-black">플레이 기록</p>
        <p className="font-['Pretendard'] text-sm tracking-[-0.5px] text-gray04">
          내 최고기록{' '}
          <span className="font-bold text-primary-blue">{bestLog ? `${bestLog.timeText} (${bestLog.diffText === '정확!' ? '정확!' : bestLog.diffText})` : '---'}</span>
        </p>
      </div>
      <div className="relative my-4 h-0 w-full">
        <div
          className="absolute left-0 top-0 h-px w-full"
          style={{
            background: 'linear-gradient(90deg, #FFFFFF 0%, #D9D9D9 50%, #FFFFFF 100%)',
            boxShadow: '0 0 10px 0 rgba(255,255,255,1)',
          }}
        />
      </div>
      <div className={visiblePlayLogs.length ? 'space-y-2.5 px-[5px]' : 'flex flex-1 items-center justify-center px-[5px]'}>
        {visiblePlayLogs.length ? (
          visiblePlayLogs.map((log) => (
            <div key={log.id} className={["flex items-center justify-between font-['Pretendard'] text-sm tracking-[-0.5px]", log.tone].join(' ')}>
              <p className="font-bold">{log.timeText}</p>
              <p>{log.diffText}</p>
            </div>
          ))
        ) : (
          <p className="text-center font-['Pretendard'] text-sm tracking-[-0.5px] text-gray03">아직 기록이 없습니다</p>
        )}
      </div>
      {shouldShowPlayLogToggle && (
        <button
          type="button"
          className="mt-4 inline-flex w-full items-center justify-center gap-1.5 font-['Pretendard'] text-sm font-normal leading-normal tracking-[-0.5px] text-gray03 focus:outline-none"
          style={{
            height: '32px',
            border: '1px solid #D9D9D9',
            borderRadius: '5px',
            backgroundColor: '#FFFFFF',
            boxSizing: 'border-box',
            paddingTop: '6px',
            paddingBottom: '4px',
            paddingLeft: '24px',
            paddingRight: '24px',
            appearance: 'none',
            WebkitAppearance: 'none',
          }}
          onClick={onToggleLogs}
        >
          {isLogsExpanded ? '접기' : '더보기'}
          <img src={MORE_CHEVRON_IMAGE} alt="" className={`h-6 w-6 ${isLogsExpanded ? 'rotate-180' : ''}`} />
        </button>
      )}
    </section>
  );
}
